import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useStore } from "react-redux";
import { Button } from '../components/atoms/button';
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import '../resources/css/login/login.css';
import Const from '../const/Const';
import commonUtil from '../common/commonUtil';

export const CrawlLoginCheck = (props) => {
    const history = useHistory();
    const store = useStore();
    const openInfo = store.getState().crawlOpenInfo;
    const memberInfo = store.getState().crawlMember;
    const [displayFlg, setDisplayFlg] = useState(false);
    const [displayText, setDisplayText] = useState("");

    //画面読み込み時に1度だけしか実行させない
    useLayoutEffect(() => {
        let loginDate = new Date();
        let loginHour = loginDate.getHours().toString();
        let loginMinute = loginDate.getMinutes() < 10 ? "0" + loginDate.getMinutes().toString() : loginDate.getMinutes().toString();
        const loginTime = Number(loginHour + loginMinute);
        
        let checkResultText = "";
        if (memberInfo.crawl_flg === "0") {
            // CRAWL区分が0の場合、モーダルを表示
            setDisplayFlg(true);
            checkResultText = "権限がないためCRAWLを利用できません";
        } else if (loginTime < Number(openInfo.open) || loginTime > Number(openInfo.close)) {
            // 現在時刻が利用可能時間外の場合、モーダルを表示
            setDisplayFlg(true);
            let openHour = "";
            let openMinute = "";
            let closeHour = "";
            let closeMinute = "";
            if(openInfo.open.length == 3){
                openHour = openInfo.open.slice(0, 1);
                openMinute = openInfo.open.slice(1);
            } else {
                openHour = openInfo.open.slice(0, 2);
                openMinute = openInfo.open.slice(2);
            }
            const openTime = openHour + ":" + openMinute;
            if(openInfo.close.length == 3){
                closeHour = openInfo.close.slice(0, 1);
                closeMinute = openInfo.close.slice(1);
            } else {
                closeHour = openInfo.close.slice(0, 2);
                closeMinute = openInfo.close.slice(2);
            }
            const closeTime = closeHour + ":" + closeMinute;
            checkResultText = openTime + " ~ " + closeTime + "の間のみ利用可能となります。";
        }
        setDisplayText(checkResultText);
    }, []);

    //ログアウト処理
    const logoutClick = () => {
        history.push("/reserve/hotel/crawlLogin");
    };

    return (
        <div>
            {displayFlg ?
                <div className='modalBody'>
                    <div className='modalContent'>
                        <div className='modalArea'>
                            <div>
                                <div className='modalText'>
                                    {displayText} <br/>
                                </div>
                                <div className='modalBtnArea'>
                                    <Button
                                        onClick={logoutClick}
                                        buttonText={"ログイン画面へ"}
                                        className="logoutBtn"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    )
}